import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { NeedsDriversLicensePhotoUploadedDto, NeedsDriversLicensePhotoUploadedQueryParams } from 'dtos/toDoLists/outboundTrips'
import { NeedsDriversLicensePhotoUploadedOutboundTripDetailDto } from 'dtos/toDoLists/outboundTrips/NeedsDriversLicensePhotoUploadedOutboundTripDetailDto'
import { objectToFormData, URIQuery } from 'utils'

const baseUrl = (): string => `/api/to-do-lists/outbound-trips/needs-drivers-license-photo-uploaded`
const guidUrl = (outboundTripGuid: string): string => `${baseUrl()}/${encodeURIComponent(outboundTripGuid)}`

export const getNeedsDriversLicensePhotoUploaded = (queryParams: NeedsDriversLicensePhotoUploadedQueryParams) =>
  apiClient.get<ApiResponse<NeedsDriversLicensePhotoUploadedDto[]>>(baseUrl() + URIQuery(queryParams)).then(res => res.data)

export const getOutboundTripDetail = (outboundTripGuid: string) =>
  apiClient.get<ApiResponse<NeedsDriversLicensePhotoUploadedOutboundTripDetailDto>>(guidUrl(outboundTripGuid)).then(res => res.data)

export const uploadDriversLicensePhoto = (data: NeedsDriversLicensePhotoUploadedOutboundTripDetailDto) =>
  apiClient<undefined>({
    data: objectToFormData(data),
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: baseUrl()
  }).then(res => res.data)
